import { createFeatureSelector, createSelector } from '@ngrx/store'
import { KnowledgeState } from '../state/knowledge.state'

const getKnowledgeState = createFeatureSelector<KnowledgeState>('knowledge')

export const getKnowledgeDetails = () =>
  createSelector(getKnowledgeState, state => {
    return state?.details
  })

export const getKnowledgeSearch = () =>
  createSelector(getKnowledgeState, state => {
    return state?.search
  })

  export const quickSelectList = () =>
    createSelector(getKnowledgeState, state => {
      return state?.quickViewList
    })